var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTooltipGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 398,
    height: 329,
    viewBox: "0 0 398 329",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.9693 277.211L92.9111 229.424C122.996 243.416 156.358 250.535 177.287 230.064C221.375 186.945 248.755 171.273 290.855 233.757L293.913 185.008L364.605 198.104C370.272 199.155 375.194 195.777 374.416 191.314C369.712 164.277 347.414 82.9187 247.69 57.4077C192.19 43.2077 141.874 58.9509 103.777 80.0087C78.8987 33.7445 66.8865 -5.38091 53.2072 2.91744C38.4624 11.8593 18.877 177.448 26.4062 185.702C29.0567 188.607 43.08 200.301 62.0437 212.358L27.743 262.118L59.9693 277.211Z",
    fill: "#00FAB0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltipGreen);
export default __webpack_public_path__ + "static/media/tooltip-green.c04ca00f70f9c0b7a601c33be5957456.svg";
export { ForwardRef as ReactComponent };